<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      clip-rule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.8 7C12.8 6.55817 12.4418 6.2 12 6.2C11.5582 6.2 11.2 6.55817 11.2 7V11.8764C11.2 12.2552 11.414 12.6014 11.7528 12.7708L15.6422 14.7155C16.0374 14.9131 16.518 14.753 16.7155 14.3578C16.9131 13.9626 16.753 13.482 16.3578 13.2845L12.8 11.5056V7Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
